"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.border = void 0;
var type_guard_1 = require("@webnuts/type-guard");
var color_1 = require("./color");
var measure_unit_1 = require("./measure-unit");
var STYLE = type_guard_1.enums(['none', 'dotted', 'dashed', 'solid']);
exports.border = type_guard_1.props({
    color: type_guard_1.optional(color_1.color.any),
    width: type_guard_1.optional(measure_unit_1.measureUnit),
    style: type_guard_1.optional(type_guard_1.union([
        STYLE,
        type_guard_1.props({
            top: type_guard_1.optional(STYLE),
            bottom: type_guard_1.optional(STYLE),
            left: type_guard_1.optional(STYLE),
            right: type_guard_1.optional(STYLE)
        })
    ])),
    radius: type_guard_1.optional(type_guard_1.union([
        measure_unit_1.measureUnit,
        type_guard_1.props({
            topRight: type_guard_1.optional(measure_unit_1.measureUnit),
            topLeft: type_guard_1.optional(measure_unit_1.measureUnit),
            bottomRight: type_guard_1.optional(measure_unit_1.measureUnit),
            bottomLeft: type_guard_1.optional(measure_unit_1.measureUnit)
        })
    ]))
});
